import axios from 'axios';
import serviceconfig from './serviceConfig';

export default {
  async authenticate(idtoken) {
    const logininfo = { token: idtoken };
    return axios.post(`${serviceconfig.apiBase}/auth/token`, logininfo);
  },
};
